var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM9.4305 6.73079C9.5656 6.73079 9.68033 6.77707 9.77488 6.86981C9.86945 6.96255 9.91674 7.07506 9.91667 7.20751V10.0681C9.91667 10.2006 9.86933 10.3132 9.77488 10.4059C9.68044 10.4985 9.5656 10.5449 9.4305 10.5449H4.56944C4.43445 10.5449 4.31965 10.4985 4.22511 10.4059C4.1306 10.3132 4.08333 10.2006 4.08333 10.0681V7.20749C4.08333 7.07505 4.13058 6.96242 4.22511 6.86979C4.31965 6.77716 4.43445 6.73077 4.56944 6.73077H4.73146V5.14157C4.73146 4.529 4.95341 4.0051 5.39731 3.56974C5.84128 3.13433 6.37549 2.91667 7.00004 2.91667C7.62455 2.91667 8.15881 3.13433 8.60274 3.56976C9.04661 4.00517 9.26857 4.52901 9.26857 5.14159C9.26857 5.22764 9.2364 5.30213 9.17244 5.36503C9.10822 5.42795 9.03228 5.45941 8.94457 5.45941H8.62034C8.53269 5.45941 8.45671 5.42795 8.39248 5.36503C8.3284 5.30213 8.29635 5.22764 8.29635 5.14159C8.29635 4.7906 8.16974 4.49099 7.91652 4.24266C7.66341 3.99436 7.35787 3.87022 7.00004 3.87022C6.64218 3.87022 6.3367 3.99438 6.08348 4.24266C5.83028 4.49099 5.70366 4.79058 5.70366 5.14159V6.73079H9.4305Z",
    fill: "#0FB11F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFace);
export default __webpack_public_path__ + "static/media/active_face.52ca202be8ab70a842f32a90a877b25a.svg";
export { ForwardRef as ReactComponent };